var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.982 18.7249C17.2833 17.7998 16.3793 17.0496 15.3412 16.5333C14.3031 16.0171 13.1594 15.7489 12 15.7499C10.8407 15.7489 9.6969 16.0171 8.65883 16.5333C7.62077 17.0496 6.71675 17.7998 6.01801 18.7249M17.982 18.7249C19.3455 17.5121 20.3071 15.9135 20.7412 14.141C21.1753 12.3686 21.0603 10.506 20.4115 8.80043C19.7627 7.09482 18.6107 5.62673 17.1084 4.59085C15.6061 3.55497 13.8244 3.00024 11.9995 3.00024C10.1747 3.00024 8.39295 3.55497 6.89062 4.59085C5.38829 5.62673 4.23634 7.09482 3.58755 8.80043C2.93875 10.506 2.82376 12.3686 3.25783 14.141C3.6919 15.9135 4.65451 17.5121 6.01801 18.7249M17.982 18.7249C16.336 20.1931 14.2056 21.0031 12 20.9999C9.79404 21.0033 7.66425 20.1934 6.01801 18.7249M15 9.74995C15 10.5456 14.6839 11.3087 14.1213 11.8713C13.5587 12.4339 12.7957 12.7499 12 12.7499C11.2044 12.7499 10.4413 12.4339 9.87869 11.8713C9.31608 11.3087 9.00001 10.5456 9.00001 9.74995C9.00001 8.9543 9.31608 8.19124 9.87869 7.62863C10.4413 7.06602 11.2044 6.74995 12 6.74995C12.7957 6.74995 13.5587 7.06602 14.1213 7.62863C14.6839 8.19124 15 8.9543 15 9.74995Z",
    stroke: "#556987",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.f2ca04491f5b83305477f8c803dea08a.svg";
export { ForwardRef as ReactComponent };